import { put, all, takeLatest, select } from "redux-saga/effects";
import {
  REQNotificationList,
  RESNotificationList,
  FailNotificationList,
  SENDxNotification,
  DELxNotification,
  SETxNotificationStatus
} from "./actions";
import * as actions from "../../Authentication/redux/actions";
import { NOTIFICATION_ADMIN_URL, authHeaders, readError } from "../api";

function* adminSession() {
  const accessToken = yield select(state => state.auth.accessToken);
  const tGUID = yield select(state => state.auth.GUID);
  return authHeaders(accessToken, tGUID);
}

/* GET /api/v1/admin/notifications?search=&status=&page=&limit= */
function* fetchNotificationListWorker({ payload }) {
  try {
    const headers = yield adminSession();
    const query = new URLSearchParams();
    const filters = payload || {};

    if (filters.search) {
      query.set("search", filters.search);
    }
    if (filters.status && filters.status !== "ALL") {
      query.set("status", filters.status);
    }
    if (filters.sendStatus && filters.sendStatus !== "ALL") {
      query.set("sendStatus", filters.sendStatus);
    }
    query.set("page", String(filters.page || 1));
    query.set("limit", String(filters.limit || 20));

    const request = yield fetch(`${NOTIFICATION_ADMIN_URL}?${query.toString()}`, {
      method: "GET",
      headers
    });

    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    if (!request.ok) {
      const message = yield readError(request);
      yield put(FailNotificationList({ message }));
      return;
    }

    const response = yield request.json();
    yield put(RESNotificationList(response));
  } catch (error) {
    yield put(FailNotificationList({ message: error.message }));
  }
}

/* POST /api/v1/admin/notifications/:id/send */
function* sendNotificationWorker({ payload }) {
  try {
    const headers = yield adminSession();
    const request = yield fetch(`${NOTIFICATION_ADMIN_URL}/${payload.id}/send`, {
      method: "POST",
      headers
    });

    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    if (!request.ok) {
      const message = yield readError(request);
      yield put(FailNotificationList({ message }));
      return;
    }

    yield fetchNotificationListWorker({ payload: payload.filters });
  } catch (error) {
    yield put(FailNotificationList({ message: error.message }));
  }
}

/* DELETE /api/v1/admin/notifications/:id */
function* deleteNotificationWorker({ payload }) {
  try {
    const headers = yield adminSession();
    const request = yield fetch(`${NOTIFICATION_ADMIN_URL}/${payload.id}`, {
      method: "DELETE",
      headers
    });

    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    if (!request.ok) {
      const message = yield readError(request);
      yield put(FailNotificationList({ message }));
      return;
    }

    yield fetchNotificationListWorker({ payload: payload.filters });
  } catch (error) {
    yield put(FailNotificationList({ message: error.message }));
  }
}

/*
 * PUT /api/v1/admin/notifications/:id/status
 *
 * The only change a delivered campaign accepts: deactivating it hides it from every
 * customer's inbox while its Reach / View history stays.
 */
function* setNotificationStatusWorker({ payload }) {
  try {
    const headers = yield adminSession();
    const request = yield fetch(`${NOTIFICATION_ADMIN_URL}/${payload.id}/status`, {
      method: "PUT",
      headers,
      body: JSON.stringify({ status: payload.status })
    });

    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    if (!request.ok) {
      const message = yield readError(request);
      yield put(FailNotificationList({ message }));
      return;
    }

    yield fetchNotificationListWorker({ payload: payload.filters });
  } catch (error) {
    yield put(FailNotificationList({ message: error.message }));
  }
}

export function* notificationListSaga() {
  yield all([
    takeLatest(REQNotificationList, fetchNotificationListWorker),
    takeLatest(SENDxNotification, sendNotificationWorker),
    takeLatest(DELxNotification, deleteNotificationWorker),
    takeLatest(SETxNotificationStatus, setNotificationStatusWorker)
  ]);
}
